var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    username: "taylor+taylor@haiku.ai",
    uuid: "ad18a731-ed77-4085-88b7-419d3fe4f2f8",
    organization: "taylor",
    project: "heroine",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/heroine",
    version: "0.0.15",
    root: "https://cdn.haiku.ai/e062580c-8941-425f-9ce7-f01d8d3a6bef/07ee961d5f9b270810efecb4f5013685c38388c4/",
    core: "4.2.0",
    title: "Orange",
    type: "haiku",
    relpath: "code/orange/code.js"
  },
  options: {},
  states: {
    lift: { type: "number", value: 20, edited: true },
    finished: { type: "boolean", value: false, edited: true }
  },
  eventHandlers: {
    "haiku:Orange-ebf4ff74488c4422": {
      "timeline:Default:0": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      playOrange: {
        handler: function(component, element, target, event) {
          let frame = this.state.finished ? 90 : 1;
          this.getDefaultTimeline().gotoAndPlay(frame);
        }
      },
      "timeline:Default:175": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      "timeline:Default:89": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      }
    },
    "haiku:Slot-16b3693a3adb9e86": {},
    "haiku:Wire-c63431d6c39935e3": {},
    "haiku:Sm-d1029994ada68b74": {},
    "haiku:Lg-ee8b869e1a12f492": {},
    "haiku:Md-d905655ec1ed4080": {},
    "haiku:Shad-Lg-5a0c3f32c73edaa8": {},
    "haiku:Shad-Md-97485d9b81cd41dc": {},
    "haiku:Shad-Wire-16255de3a30a2b3a": {},
    "haiku:Shad-Sm-739e5655ca015ed9": {}
  },
  timelines: {
    Default: {
      "haiku:Group-c8663c57c9b13b8f": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.70703125,
        "translation.x": -2.51,
        "translation.y": -12.887
      },
      "haiku:Orange-ebf4ff74488c4422": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 215,
        "sizeAbsolute.y": 211,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Slot-16b3693a3adb9e86": {
        "translation.y": 103,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 107.5,
        "style.position": "absolute",
        "sizeAbsolute.x": 93,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 89,
        "sizeMode.y": 1,
        "style.zIndex": 1,
        opacity: {
          "0": { value: 1, edited: true },
          "517": { value: 0, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        }
      },
      "haiku:Group-2fdbfee23d12a996": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none"
      },
      "haiku:slot-758cc35c48b84b7e": {
        fill: "#1B2226",
        x: 0,
        y: 0,
        width: 93,
        height: 89,
        rx: 10
      },
      "haiku:Wire-c63431d6c39935e3": {
        "translation.y": 108,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 100.423,
        "style.position": "absolute",
        "sizeAbsolute.x": 47.82754898071289,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 55.22650146484375,
        "sizeMode.y": 1,
        "style.zIndex": 6,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift - 15;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "1167": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "1167": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1733": { value: 1, edited: true, curve: "easeInBack" },
          "2167": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2917": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "1167": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1733": { value: 1, edited: true, curve: "easeInBack" },
          "2167": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2917": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1733": { value: 0, edited: true, curve: "easeOutCubic" },
          "2917": { value: 6.28, edited: true }
        }
      },
      "haiku:wire-c849b92ebfee8046": {
        d:
          "M26.4233938,12.8867513 L2.50961894,26.6933757 L2.50961894,54.3066243 L26.4233938,68.1132487 L50.3371686,54.3066243 L50.3371686,26.6933757 L26.4233938,12.8867513 Z",
        stroke: "#F8BE64",
        strokeWidth: 5
      },
      "haiku:Sm-d1029994ada68b74": {
        "sizeMode.x": 1,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 95.392,
        "style.position": "absolute",
        "translation.y": 102.5,
        "sizeAbsolute.x": 20.784610748291016,
        "sizeAbsolute.y": 24,
        "sizeMode.y": 1,
        "style.zIndex": 7,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift + 15;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "950": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "933": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1500": { value: 1, edited: true, curve: "easeInBack" },
          "1933": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2683": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "933": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1500": { value: 1, edited: true, curve: "easeInBack" },
          "1933": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2683": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2683": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-43bc03ce1efc1ce3": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.70703125,
        "translation.x": -16,
        "translation.y": -23
      },
      "haiku:sm-44cecf75b5a63138": {
        fill: "#F8BE64",
        points:
          "26.3923048 23 36.7846097 29 36.7846097 41 26.3923048 47 16 41 16 29"
      },
      "haiku:Lg-ee8b869e1a12f492": {
        "translation.y": 116,
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 88.619,
        "style.position": "absolute",
        "style.overflow": "visible",
        "sizeAbsolute.x": 37.23908996582031,
        "sizeAbsolute.y": 43,
        "sizeMode.y": 1,
        "style.zIndex": 8,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2700": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-97cd08bd0ef6dc61": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.70703125,
        "translation.x": -31,
        "translation.y": -27
      },
      "haiku:lg-29431867826d4a3c": {
        fill: "#F8BE64",
        points:
          "49.6195462 27 68.2390924 37.75 68.2390924 59.25 49.6195462 70 31 59.25 31 37.75"
      },
      "haiku:Md-d905655ec1ed4080": {
        "translation.y": 84.5,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 94.999,
        "style.position": "absolute",
        "sizeAbsolute.x": 29.444862365722656,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 34,
        "sizeMode.y": 1,
        "style.zIndex": 9,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift + 20;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "733": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1500": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1500": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2683": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-7e49512df1b7decc": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.70703125,
        "translation.x": -11.278
      },
      "haiku:md-35cf3a037d992fdb": {
        fill: "#F8BE64",
        points:
          "26 0 40.7224319 8.5 40.7224319 25.5 26 34 11.2775681 25.5 11.2775681 8.5"
      },
      "haiku:Shad-Sm-739e5655ca015ed9": {
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 90.392,
        "style.position": "absolute",
        "sizeAbsolute.x": 20.784610748291016,
        "translation.y": 111.5,
        "sizeAbsolute.y": 24,
        "sizeMode.y": 1,
        "style.zIndex": 2,
        opacity: {
          "0": { value: 0, edited: true },
          "950": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "950": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1500": { value: 1, edited: true, curve: "easeInBack" },
          "1950": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2700": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "950": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1500": { value: 1, edited: true, curve: "easeInBack" },
          "1950": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2700": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2700": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-b1e0223b7068c397": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -16,
        "translation.y": -23
      },
      "haiku:shad_sm-1b9339eba369b8d9": {
        fill: "#1B2226",
        points:
          "26.3923048 23 36.7846097 29 36.7846097 41 26.3923048 47 16 41 16 29"
      },
      "haiku:Shad-Lg-5a0c3f32c73edaa8": {
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 83.619,
        "style.position": "absolute",
        "sizeAbsolute.x": 37.23908996582031,
        "translation.y": 125,
        "sizeAbsolute.y": 43,
        "sizeMode.y": 1,
        "style.zIndex": 5,
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1083": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            curve: "easeInBack",
            edited: true
          },
          "1933": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2683": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1083": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            curve: "easeInBack",
            edited: true
          },
          "1933": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2683": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2683": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-6a5fc970c23088e2": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -31,
        "translation.y": -27
      },
      "haiku:shad_lg-d525ad807ab53173": {
        fill: "#1B2226",
        points:
          "49.6195462 27 68.2390924 37.75 68.2390924 59.25 49.6195462 70 31 59.25 31 37.75"
      },
      "haiku:Shad-Wire-16255de3a30a2b3a": {
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 90.423,
        "style.position": "absolute",
        "sizeAbsolute.x": 47.82754898071289,
        "translation.y": 117,
        "sizeAbsolute.y": 55.22650146484375,
        "sizeMode.y": 1,
        "style.zIndex": 3,
        opacity: {
          "0": { value: 0, edited: true },
          "1167": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "1167": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1733": { value: 1, edited: true, curve: "easeInBack" },
          "2167": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2917": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "1167": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1733": { value: 1, edited: true, curve: "easeInBack" },
          "2167": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2917": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1733": { value: 0, edited: true, curve: "easeOutCubic" },
          "2917": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-ca745a58042f3a3f": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -2.51,
        "translation.y": -12.887
      },
      "haiku:shad_wire-97808ac73bf789b2": {
        d:
          "M26.4233938,12.8867513 L2.50961894,26.6933757 L2.50961894,54.3066243 L26.4233938,68.1132487 L50.3371686,54.3066243 L50.3371686,26.6933757 L26.4233938,12.8867513 Z",
        stroke: "#1B2226",
        strokeWidth: 5
      },
      "haiku:Shad-Md-97485d9b81cd41dc": {
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 89.999,
        "style.position": "absolute",
        "sizeAbsolute.x": 29.444862365722656,
        "translation.y": 93.5,
        "sizeAbsolute.y": 34,
        "sizeMode.y": 1,
        "style.zIndex": 4,
        opacity: {
          "0": { value: 0, edited: true },
          "733": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1500": { value: 1, edited: true, curve: "easeInBack" },
          "1933": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2683": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1500": { value: 1, edited: true, curve: "easeInBack" },
          "1933": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2683": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2683": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-11fec237a2a7cd96": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -11.278
      },
      "haiku:shad_md-8a91380373b49b66": {
        fill: "#1B2226",
        points:
          "26 0 40.7224319 8.5 40.7224319 25.5 26 34 11.2775681 25.5 11.2775681 8.5"
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Orange-ebf4ff74488c4422",
      "haiku-title": "Orange"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Md-97485d9b81cd41dc",
          "haiku-title": "shad_md",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_orange.svg#shadow#shad_md"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-11fec237a2a7cd96" },
            children: [
              {
                elementName: "polygon",
                attributes: {
                  "haiku-id": "shad_md-8a91380373b49b66",
                  id: "shad_md"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Wire-16255de3a30a2b3a",
          "haiku-title": "shad_wire",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_orange.svg#shadow#shad_wire"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-ca745a58042f3a3f" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "shad_wire-97808ac73bf789b2",
                  id: "shad_wire"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Lg-5a0c3f32c73edaa8",
          "haiku-title": "shad_lg",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_orange.svg#shadow#shad_lg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-6a5fc970c23088e2" },
            children: [
              {
                elementName: "polygon",
                attributes: {
                  "haiku-id": "shad_lg-d525ad807ab53173",
                  id: "shad_lg"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Sm-739e5655ca015ed9",
          "haiku-title": "shad_sm",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_orange.svg#shadow#shad_sm"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-b1e0223b7068c397" },
            children: [
              {
                elementName: "polygon",
                attributes: {
                  "haiku-id": "shad_sm-1b9339eba369b8d9",
                  id: "shad_sm"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Md-d905655ec1ed4080",
          "haiku-title": "md",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_orange.svg#thing#md"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-7e49512df1b7decc" },
            children: [
              {
                elementName: "polygon",
                attributes: { "haiku-id": "md-35cf3a037d992fdb", id: "md" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Lg-ee8b869e1a12f492",
          "haiku-title": "lg",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_orange.svg#thing#lg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-97cd08bd0ef6dc61" },
            children: [
              {
                elementName: "polygon",
                attributes: { "haiku-id": "lg-29431867826d4a3c", id: "lg" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Sm-d1029994ada68b74",
          "haiku-title": "sm",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_orange.svg#thing#sm"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-43bc03ce1efc1ce3" },
            children: [
              {
                elementName: "polygon",
                attributes: { "haiku-id": "sm-44cecf75b5a63138", id: "sm" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Wire-c63431d6c39935e3",
          "haiku-title": "wire",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_orange.svg#thing#wire"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-c8663c57c9b13b8f" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "wire-c849b92ebfee8046", id: "wire" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Slot-16b3693a3adb9e86",
          "haiku-title": "slot",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_orange.svg#slot"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-2fdbfee23d12a996" },
            children: [
              {
                elementName: "rect",
                attributes: { "haiku-id": "slot-758cc35c48b84b7e", id: "slot" },
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-heroine/code/orange/code.js
// module id = 524
// module chunks = 35783957827783